import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ekostratejiLogo from '../assets/ekostrateji-logo.png';

const AuthLayout: React.FC = () => {
  const location = useLocation();
  
  // Sayfa tipine göre genişlik ayarı
  const isKVKKPage = location.pathname.includes('kvkk');
  const contentMaxWidth = isKVKKPage ? 'max-w-4xl' : 'max-w-md';
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className={`${contentMaxWidth} w-full space-y-8`}>
        <div className="flex flex-col items-center">
          <img 
            src={ekostratejiLogo} 
            alt="Ekostrateji Logo" 
            className="h-16 mb-4"
          />
          <h2 className="text-center text-2xl font-bold text-gray-900">
            Sürdürülebilirlik Raporu Uygulaması
          </h2>
        </div>
        
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
        
        <div className="mt-6 text-center text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} Ekostrateji. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
